module.exports = __webpack_public_path__ + "static/tailie_bg-d1527597f0db657d4cec90030033ad34.jpg";